import { Observable } from 'rxjs';

import { SegmentAPIMethods, SegmentClientOptions } from './analytics.types';

export const loadAnalytics = (segmentKey: string, options?: SegmentClientOptions) =>
  new Observable<SegmentAPIMethods>(observer => {
    const segmentClient = (window.analytics = window.analytics || []);

    if (segmentClient.initialize) return;

    if (segmentClient.invoked) {
      // @ts-ignore
      if (window.console && console.error) {
        observer.error('Segment snippet included twice.');
      }
      return;
    }

    segmentClient.invoked = true;
    segmentClient.methods = ['page', 'identify', 'track', 'alias', 'ready'];

    segmentClient.factory = function (method: string) {
      return function (...args: any[]) {
        args.unshift(method);
        segmentClient.push(args);
        return segmentClient;
      };
    };

    for (let i = 0; i < segmentClient.methods.length; i++) {
      const key = segmentClient.methods[i];
      segmentClient[key] = segmentClient.factory(key);
    }

    segmentClient.load = function (key: string, _options?: Record<any, any>) {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.src = 'https://cdn.segment.com/analytics.js/v1/' + key + '/analytics.min.js';

      const first = document.getElementsByTagName('script')[0];
      first.parentNode!.insertBefore(script, first);
      segmentClient._loadOptions = _options;
    };

    segmentClient.SNIPPET_VERSION = '4.1.0';

    segmentClient.load(segmentKey, options);

    segmentClient.ready(() => {
      observer.next({
        alias: (...args) => window.analytics.alias(...args),
        track: (...args) => window.analytics.track(...args),
        identify: (...args) => window.analytics.identify(...args),
        page: (...args) => window.analytics.page(...args),
        reset: (...args) => window.analytics.reset(...args),
      });

      observer.complete();
    });
  });
